import { render, staticRenderFns } from "./Caseapprove.vue?vue&type=template&id=24b1268a&scoped=true&"
import script from "./Caseapprove.vue?vue&type=script&lang=js&"
export * from "./Caseapprove.vue?vue&type=script&lang=js&"
import style0 from "./Caseapprove.vue?vue&type=style&index=0&id=24b1268a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b1268a",
  null
  
)

export default component.exports